import { omit } from "@styled-system/props";
import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { forwardRef } from "react";
import { createHook } from "reakit-system";
import { cx, ecss } from "../reexports/emotion";
import type { BoxOptions } from "../Box/Box";
import { Box } from "../Box/Box";
import { CheckablesWrapper } from "../hooks/checkables/CheckablesWrapper";

function CheckboxIcon() {
  return (
    <Box
      className="icon"
      borderWidth="1"
      size="checkableSize"
      borderRadius="checkboxBorderRadius"
      aria-hidden="true"
      position="relative"
    />
  );
}

// eslint-disable-next-line @typescript-eslint/ban-types -- здесь нам нужно any, не равное undefined или null
const useCheckboxInput = createHook<{}, InputHTMLAttributes<HTMLInputElement>>({
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        props.className,
        ecss({
          label: "Checkbox",
          opacity: 0,
          zIndex: -1,
          width: 1,
          height: 1,
          overflow: "hidden",
          position: "absolute",
        })
      ),
    };
  },
});

const Input = forwardRef(
  ({ ...props }: InputHTMLAttributes<HTMLInputElement>, ref: Ref<HTMLInputElement>) => {
    const styledProps = useCheckboxInput({}, props);

    return <input ref={ref} {...styledProps} />;
  }
);

export type CheckboxProps = {
  hasError?: boolean;
  label?: ReactNode;
  hint?: ReactNode;
} & BoxOptions &
  InputHTMLAttributes<HTMLInputElement>;

/**
 * @beta
 */

export const Checkbox = forwardRef(function Checkbox(
  { hasError, disabled, label, hint, width, ...props }: CheckboxProps,
  ref: Ref<HTMLInputElement>
) {
  const inputProps: InputHTMLAttributes<HTMLInputElement> = omit(props);

  return (
    <CheckablesWrapper
      width={width}
      hasError={hasError}
      disabled={disabled}
      inputType="Checkbox"
      label={label}
      hint={hint}
    >
      <Input type="checkbox" {...inputProps} ref={ref} disabled={disabled} />
      <CheckboxIcon />
    </CheckablesWrapper>
  );
});
